import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.625 4.75H15.5c.957 0 1.75.793 1.75 1.75V17c0 .984-.793 1.75-1.75 1.75H7.625c-.984 0-1.75-.766-1.75-1.75V6.5c0-.957.766-1.75 1.75-1.75m3.063 7.875c-1.231 0-2.188.984-2.188 2.188 0 .246.191.437.438.437h5.25a.45.45 0 0 0 .437-.437 2.194 2.194 0 0 0-2.187-2.188zM9.812 10c0 .629.329 1.203.876 1.531.519.301 1.203.301 1.75 0 .519-.328.874-.902.874-1.531 0-.602-.355-1.176-.874-1.504-.547-.3-1.231-.3-1.75 0A1.77 1.77 0 0 0 9.812 10M19 6.938v1.75a.45.45 0 0 1-.437.437.43.43 0 0 1-.438-.437v-1.75a.45.45 0 0 1 .438-.438.47.47 0 0 1 .437.438M18.563 10a.47.47 0 0 1 .437.438v1.75a.45.45 0 0 1-.437.437.43.43 0 0 1-.438-.437v-1.75a.45.45 0 0 1 .438-.438M19 13.938v1.75a.45.45 0 0 1-.437.437.43.43 0 0 1-.438-.437v-1.75a.45.45 0 0 1 .438-.438.47.47 0 0 1 .437.438"
    }, null, -1)
  ]))]))
}
export default { render: render }